module.exports = __webpack_public_path__ + "static/img/BEAU-ADDINSALL.a987788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BEAU-ADDINSALL.jpg
// module id = gvrr
// module chunks = 0